/* P1 draft, 2026-11-02. Presentation only: no cart retries or network requests. */
(function () {
  'use strict';
  if (window.fliteConfiguratorCartFeedback) return;
  var selector = '.cfg-info__atc-button, .cfg-atc-sticky__atc-button';
  var pending = false;
  var saved = new Map();
  var observer = null;
  var opener = null;
  function region() { return document.getElementById('flite-configurator-cart-feedback'); }
  function busyButtons() {
    document.querySelectorAll(selector).forEach(function (button) {
      if (!saved.has(button)) {
        saved.set(button, { disabled: button.disabled, busy: button.getAttribute('aria-busy') });
      }
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    });
  }
  function hide() {
    var box = region();
    if (box) box.hidden = true;
  }
  function start() {
    if (pending) return;
    pending = true;
    opener = document.activeElement;
    hide();
    busyButtons();
    var main = document.querySelector('configurator-main');
    if (main) {
      observer = new MutationObserver(busyButtons);
      observer.observe(main, { childList: true, subtree: true });
    }
  }
  function error() {
    var box = region();
    if (!box) return;
    // A rejected or interrupted request may have changed the cart. Do not auto-retry.
    box.hidden = false;
    box.focus();
  }
  function finish() {
    pending = false;
    if (observer) observer.disconnect();
    observer = null;
    saved.forEach(function (state, button) {
      if (!button.isConnected) return;
      button.disabled = state.disabled;
      if (state.busy === null) button.removeAttribute('aria-busy');
      else button.setAttribute('aria-busy', state.busy);
    });
    saved.clear();
  }
  document.addEventListener('click', function (event) {
    if (!event.target.closest || !event.target.closest('[data-flite-cart-error-dismiss]')) return;
    hide();
    var target = opener && opener.isConnected && !opener.disabled ? opener : null;
    if (!target) target = Array.from(document.querySelectorAll(selector)).find(function (button) { return !button.disabled; });
    if (target) target.focus();
  });
  window.fliteConfiguratorCartFeedback = { start: start, error: error, finish: finish };
})();
